module.exports = __webpack_public_path__ + "static/media/reports_inventory.843f0f56.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_inventory.md
// module id = 1112
// module chunks = 0